import { render, staticRenderFns } from "./AccountVerificationModal.vue?vue&type=template&id=51be36c6&scoped=true&"
import script from "./AccountVerificationModal.vue?vue&type=script&lang=js&"
export * from "./AccountVerificationModal.vue?vue&type=script&lang=js&"
import style1 from "./AccountVerificationModal.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51be36c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1751410358/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51be36c6')) {
      api.createRecord('51be36c6', component.options)
    } else {
      api.reload('51be36c6', component.options)
    }
    module.hot.accept("./AccountVerificationModal.vue?vue&type=template&id=51be36c6&scoped=true&", function () {
      api.rerender('51be36c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/NewUI/components/customer/authorizations/shared/AccountVerificationModal.vue"
export default component.exports